<script>
  import { twMerge } from 'tailwind-merge';

  let { size = 'md' } = $props();

  const sizeClasses = $derived(
    {
      sm: 'w-[12px] h-[12px]',
      md: 'w-[14px] h-[14px]',
      lg: 'w-[20px] h-[20px]',
      xl: 'w-[32px] h-[32px]',
      '2xl': 'w-[48px] h-[48px]',
    }[size],
  );

  const classes = $derived(twMerge(['animate-spin', sizeClasses]));
</script>

<svg
  class={classes}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M1 8V8C0.999999 11.866 4.13401 15 8 15V15" stroke="currentColor" />
  <path d="M15 8V8C15 4.13401 11.866 1 8 1V1" stroke="currentColor" />
  <path
    d="M12.9503 3.05029V3.05029C10.2166 0.316623 5.78445 0.316623 3.05078 3.05029V3.05029"
    stroke="url(#paint0_linear_19677_78241)"
  />
  <path
    d="M3.04972 12.95V12.95C5.78339 15.6836 10.2155 15.6836 12.9492 12.95V12.95"
    stroke="url(#paint1_linear_19677_78241)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_19677_78241"
      x1="3.1"
      y1="3.1002"
      x2="6.6"
      y2="1.0002"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="currentColor" stop-opacity="0" />
      <stop offset="1" stop-color="currentColor" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_19677_78241"
      x1="12.9"
      y1="12.9"
      x2="9.4"
      y2="15"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="currentColor" stop-opacity="0" />
      <stop offset="1" stop-color="currentColor" />
    </linearGradient>
  </defs>
</svg>
